export default (items, selectedItems) => ({
    items,
    selectedItems,

    get selectedItemsKeys(){
        if (Array.isArray(this.items)) {
            return this.selectedItems;
        }
        return Object.keys(this.selectedItems);
    },

    init(){
        if (Array.isArray(this.items)) {
            this.items = this.items.filter((item, index) => {
                return !this.selectedItems.includes(item) || this.selectedItems.indexOf(item) !== index;
            });
        }else{
            const selectedItemsKeys = this.selectedItems.map(item => String(item));

            this.selectedItems = Object.entries(this.items)
                .filter(([key, value]) => selectedItemsKeys.includes(key))
                .reduce((obj, [key, value]) => {
                    obj[key] = value;
                    return obj;
                }, {});

            this.items = Object.keys(this.items).reduce((obj, key) => {
                if (!selectedItemsKeys.includes(key)) {
                    obj[key] = this.items[key];
                }
                return obj;
            }, {});
        }
        // debugger;
    },

    selectItems() {
        this.moveItems(this.$refs.available, this.selectedItems, this.items);
    },
    selectAllItems() {
        this.moveAll(this.items, this.selectedItems);
    },
    deselectItems() {
        this.moveItems(this.$refs.selected, this.items, this.selectedItems);
    },
    deselectAllItems() {
        this.moveAll(this.selectedItems, this.items);
    },
    moveItems(selectRef, target, source) {
        if (Array.isArray(this.items)) {
            Array.from(selectRef.selectedOptions).forEach(option => {
                target.push(option.value);
                const index = source.indexOf(option.value);
                if (index > -1) {
                    source.splice(index, 1);
                }
            });
        }else{
            Array.from(selectRef.selectedOptions).forEach(option => {
                target[option.value] = option.text;
                delete source[option.value];
            });
        }
    },
    moveAll(source, target) {
        if (Array.isArray(this.items)) {
            source.forEach(item => {
                target.push(item);
            });
            source.splice(0, source.length);
        }else{
            Object.entries(source).forEach(([key, value]) => {
                target[key] = value;
                delete source[key];
            });
        }
    },

    setSelectedItems({ items }){
        this.deselectAllItems();
        Array.from(this.$refs.available.options).forEach(option => {
            option.selected = items.includes(option.value);
        });
        this.selectItems();
    }
});
